export default {
  routes: [
    {
      path: '/',
      name: 'venue',
      cname: '主会场',
      component: () => import('./views/venue/index.vue'),
    },
    {
      path: '/merchant',
      name: 'merchant',
      cname: '商户页',
      component: () => import('./views/merchant/index.vue'),
    },
  ],
};
